import { useOffline } from '../OfflineProvider';

/**
 * Whether an action that inherently requires the server should be unavailable.
 *
 * FR-018: uploading a document, triggering generation, sharing and changing a
 * password all depend on server-side work that cannot be simulated on the
 * device. Queueing them would promise the user an outcome the app cannot
 * deliver, so they are disabled outright and explained.
 */
export const useOnlineOnly = () => !useOffline().online;

/**
 * The explanation that goes with a disabled online-only action. Renders
 * nothing when online, so it costs no space in the normal case.
 */
const OfflineHint = ({ action = 'This' }) => {
  if (!useOnlineOnly()) return null;
  return (
    <p role="note" className="mt-1 text-xs text-gray-500 dark:text-gray-400">
      {action} needs a connection — it will be available again when you&apos;re back online.
    </p>
  );
};

export default OfflineHint;
